var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Field__Component" }, [
    _c(
      "div",
      [
        _vm._t("default", function () {
          return [
            _c(
              "router-link",
              {
                style: { textDecoration: "underline" },
                attrs: {
                  target: "_blank",
                  to: `/course/${_vm.courseId}/exercisePrint/${
                    _vm.item.exerciseId
                  }?showAnswers=${true}`,
                },
              },
              [_vm._v("פתרון")]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }